/**
 * Created by john on 8/24/15.
 */

'use strict';

const Fluxible = require('fluxible');


/**
 * Creates a new Fluxible object and registers the specified stores with it.
 * @param stores
 * @returns {Fluxible|exports|module.exports} The created Fluxible object
 * @constructor
 */
function AppFactory(stores = []) {
    const app = new Fluxible();

    stores.forEach(store => {
        app.registerStore(store);
    });

    return app;
}

module.exports = AppFactory;



// WEBPACK FOOTER //
// ./assets/js/global/reactHelpers/appFactory.es.js